import { render, staticRenderFns } from "./categoryEnable.vue?vue&type=template&id=2b92f156&scoped=true"
import script from "./categoryEnable.vue?vue&type=script&lang=js"
export * from "./categoryEnable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92f156",
  null
  
)

export default component.exports